<template lang="pug">
div
  v-row

    //- GRID
    v-col(:cols="(hasFilter && isFilterVisible) ? 9 : 12")
      grid-table(
        v-model="isFilterVisible"
        v-bind="$props"
        :filter="filter"
        :selection="selection"
        @refresh="refresh"
        @select="value => select(value)"
        @perform="perform"
      )

    //- FILTER
    v-col(cols="3" v-show="hasFilter && isFilterVisible")
      grid-filter(
        v-model="isFilterVisible"
        v-bind="$props"
        :filter="filter"
        :selection="selection"
        @refresh="refresh"
        @select="value => select(value)"
        @perform="perform"
      )

  //- Diálogo de confirmação de operação
  action-dialog(
    v-bind="$props"
    :request="request"
    @actionComplete="actionComplete"
    @actionTerminate="request = null"
  )

</template>

<style>
  .x-btn-navbar {
    border: 1px solid #9995;
  }
</style>

<script>
import Vue from 'vue'

import GridTable from './GridTable'
import GridFilter from './GridFilter'
import ActionDialog from '@/components/commons/action-dialog/ActionDialog'

import { hasRel } from "@/helpers/rels"

export default {
  components: {
    GridTable,
    GridFilter,
    ActionDialog,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,
  },

  data: () => ({
    /**
     * Registros selecionados na grade.
     * @type {Array}
     */
    selection: [],

    /**
     * Registros selecionados na grade.
     * @type {Object}
     *    Format:
     *    {
     *      -- Link da requisição
     *      link: {Keep.Paper.Design.Link}
     *      -- Registros afetados pela requisição.
     *      selection: {Array}
     *    }
     */
    request: null, // Parâmetros de requisição
  }),

  computed: {
    title: vm => vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    description: vm => vm.entity?.description,

    filter (vm) {
      let forms = vm.entity?.forms || []
      let filter = forms.filter(x => x.name === 'Filter')[0] || {}
      return filter;
    },
    fields: vm => vm.filter?.fields || [],
    hasFilter: vm => vm.fields.length > 0,

    isFilterVisible: {
      get () {
        return this.entity?.isFilterVisible !== undefined
          ? this.entity?.isFilterVisible : true
      },
      set (value) {
        this.$set(this.entity, 'isFilterVisible', value)
      }
    },

    // autoRefresh: vm => vm.entity?.autoRefresh || 0,
    // hasMoreData: vm => !!vm.set.hasMoreData,
    // hasSelection: vm => !!vm.selection.length,
    // hasActions: vm => !!vm.actions.length,
    // hasDataSetActions: vm => !!vm.dataSetActions.length,
  },

  methods: {
    actionComplete ({ success }) {
      if (success) {
        this.refresh()
        this.select([])
      }
    },

    select(selection) {
      this.selection = selection || []
    },

    isRowNonSelectable(row) {
      return row?.['@row']?.nonSelectable || hasRel(row?.['@row'], "Summary")
    },

    perform (opts) {
      // TODO: FIXME: Substituir pelo novo: @/helpers/actions/performAction()
      if (opts.selection) {
        // Removendo registros não-selecionáveis
        opts.selection = opts.selection.filter(row => !this.isRowNonSelectable(row));
      }

      const link = opts.link
      const rule = link?.rule || []
      const popup = !rule.some(term => term === 'Browse')

      opts.form = opts.form || {}
      this.fields.forEach(field => opts.form[field.name] = field.value)

      this._applyTemplates(opts.link)

      // Retirando os dados atuais do cache se solicitado...
      const refetch = rule.some(x => x.toLowerCase() === 'refetch')
      if (refetch) {
        this.$close(link)
      }

      if (popup) {
        this.request = opts
      } else {
        this.$go(link)
      }
    },

    _applyTemplates (link) {
      const form = link?.form
      if (!form) return

      // substituindo parametros na forma `{{ @parametro }}`...
      Object.entries(form).forEach(([key, value]) => {
        if (typeof value !== 'string' || !value?.includes('@'))
          return

        const match = /{{ *@(.*?) *}}/.exec(value)
        if (!match)
          return

        const fieldName = match[1]
        const fieldValue = this.fields.filter(
            field => field.name.toLowerCase() === fieldName.toLowerCase()
            ).map(field => field.value)[0]

        form[key] = fieldValue
      })
    },

    refresh () {
      const ok = this.$refs.form?.validate() || true
      if (!ok)
        return

      // Destacando os parâmetros da requisição...
      const form = {}
      this.fields.forEach(field => form[field.name] = field.value)

      this.$emit('refresh', { form, noCache: true, dataSetOnly: true })
    },

    isSearchField (field) {
      return field.rel?.includes('Search')
    },

    unwrapModel () {
      if (!this.blueprint || this.blueprint.set)
        return

      let fields = this.fields || []

      fields.forEach(field => {
        let hasValue = Object.prototype.hasOwnProperty.call(field, 'value')
        if (!hasValue) {
          Vue.set(field, "value", field.defaultValue || null);
        }
      })

      this.blueprint.set = true
    },
  },

  watch: {
    fields: "unwrapModel",
    $route () { this.select([]) },
  },

  mounted() {
    this.unwrapModel();
  },

  beforeDestroy() {
  },
}
</script>